import type { ReactNode } from 'react';
import { Role } from 'src/models/user';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PaymentOutlined from '@mui/icons-material/PaymentOutlined';
import ReportTwoToneIcon from '@mui/icons-material/AddchartTwoTone';
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import ChecklistIcon from '@mui/icons-material/FactCheckOutlined';
import AssignmentIndOutlined from '@mui/icons-material/AssignmentIndOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ManageSupervisorOutlinedIcon from '@mui/icons-material/SupervisorAccount';
import MoneyIcon from '@mui/icons-material/MoneyOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ReportOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import PointOfSaleTwoToneIcon from '@mui/icons-material/PointOfSaleTwoTone';
import MoneyTwoToneIcon from '@mui/icons-material/MoneyTwoTone';
import { RECEPTION_PATHS } from 'src/utils/receptionRoutes';

export interface MenuItem {
    link?: string;
    icon?: ReactNode;
    badge?: string;
    badgeTooltip?: string;

    items?: MenuItem[];
    name: string;
}

export interface MenuItems {
    items: MenuItem[];
    heading?: string;
    permission: string[];
}


const menuItems: MenuItems[] = [
    {
        permission: [Role.AGENT],
        items: [
            {
                name: 'Agent',
                icon: DashboardOutlined,
                link: '/ct/agent/dashboard',
                items: [
                    {
                        name: 'Agent Dashboard',
                        link: '/ct/agent/dashboard',
                        icon: DashboardOutlined
                    },
                    {
                        name: 'Followup',
                        link: '/ct/agent/followup',
                        icon: ViewListOutlinedIcon
                    },
                    {
                        name: 'Report',
                        link: '/ct/agent/report',
                        icon: ReportOutlinedIcon
                    },
                ]
            }
        ]
    },
    {
        permission: [Role.SUPER, Role.ADMIN],
        items: [
            {
                name: 'Dashboard',
                icon: DashboardOutlined,
                link: '/ct/dashboard',
                items: [
                    {
                        name: 'Admin Dashboard',
                        link: '/ct/dashboard/admin',
                        icon: DashboardOutlined
                    },
                    {
                        name: 'User Dashboard',
                        link: '/ct/dashboard/user',
                        icon: ViewListOutlinedIcon
                    },
                    {
                        name: 'Analytics',
                        link: '/ct/dashboard/analytics',
                        icon: ReportOutlinedIcon
                    },
                    {
                        name: 'Proforma',
                        link: '/ct/dashboard/proforma',
                        icon: ReportTwoToneIcon
                    }
                ]
            }
        ]
    },
    {
        permission: [Role.ACCOUNTANT],
        items: [
            {
                name: 'Accounting',
                icon: DashboardOutlined,
                link: '',
                items: [
                    {
                        name: 'Analytics',
                        link: '/ct/dashboard/analytics',
                        icon: ReportOutlinedIcon
                    },
                    {
                        name: 'Proforma',
                        link: '/ct/dashboard/proforma',
                        icon: ReportTwoToneIcon
                    }
                ]
            }
        ]
    },

    {
        permission: [Role.ADMIN, Role.SUPER],
        items: [
            {
                name: 'Administration',
                icon: SettingsOutlinedIcon,
                link: '',
                items: [
                    {
                        name: 'Manage Users',
                        link: '/ct/configuration/users',
                        icon: ManageAccountsOutlinedIcon
                    },
                    {
                        name: 'Manage Settings',
                        link: '/ct/configuration/settings',
                        icon: ManageSupervisorOutlinedIcon
                    }

                ]
            }
        ]
    },
    {
        permission: [Role.RECEPTIONIST, Role.CASHIER],
        items: [
            {
                name: 'Reception',
                icon: ReceiptIcon,
                link: '',
                items: [
                    {
                        name: 'Manage Client Register',
                        link: RECEPTION_PATHS.register,
                        icon: ManageAccountsOutlinedIcon
                    },
                    {
                        name: 'Check-in',
                        link: RECEPTION_PATHS.checkIn,
                        icon: ChecklistIcon
                    },
                    {
                        name: 'payment',
                        link: RECEPTION_PATHS.payment,
                        icon: PointOfSaleTwoToneIcon
                    },
                    {
                        name: 'transactions',
                        link: RECEPTION_PATHS.transactions,
                        icon: MoneyTwoToneIcon
                    }
                ]
            },

        ]
    },
    {
        permission: [Role.ADMIN, Role.CASHIER,Role.AGENT,Role.SUPER,Role.RECEPTIONIST],
        items: [
            {
                name: 'Messenger',
                icon: MessageOutlinedIcon,
                link: '/ct/configuration/messenger',
              
            },

        ]
    },
];

export default menuItems;
